import React, { useState, useEffect } from "react";
import Header from "../../components/header/Header";
import HeroSection from "../../components/HomeComponents/herosection/HeroSection";
import RecentlyPlayed from "../../components/HomeComponents/recentlyplayed/RecentlyPlayed";
import Carousel from "../../components/HomeComponents/carousel/Carousel";
import CategorySection from "../../components/HomeComponents/categorysection/CategorySection";
import Popular from "../../components/HomeComponents/popularsection/Popular";
import LatestClasses from "../../components/HomeComponents/latestClasses/LatestClasses";
import DonationSection from "../../components/HomeComponents/donationsection/DonationSection";
import Footer from "../../components/footer/Footer";

function Home() {
  const [isLoggedin, setIsLoggedin] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      setIsLoggedin(true);
    } else {
      setIsLoggedin(false);
    }
  }, []);
  return (
    <div>
      <Header />
      {isLoggedin && <RecentlyPlayed />}
      {/* {
    !isLoggedin &&
    <HeroSection/>
   } */}
      <Carousel />
      <CategorySection />
      <Popular />
      <LatestClasses />
      <DonationSection />
      <Footer />
    </div>
  );
}

export default Home;
